











import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
  data() {
    return {
      token: "",
    }
  },
  computed: {
    ...mapState(['users'])
  },
  methods: {
    async loadUsers() {
      this.$cookies.config('30d')
      this.$cookies.set('PDApiKey', this.token)
      this.$store.commit('setPipedriveToken', this.token);
      await this.$store.dispatch('loadUsers')
    }
  },
  mounted() {
    if (this.$cookies.isKey('PDApiKey')) {
      console.log('yes key')
      this.token = this.$cookies.get('PDApiKey')
    } else {
      console.log('no key')
    }
  }
})
